module.exports = __webpack_public_path__ + "static/media/GST_map.2b290120.csv";